import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0de20e56&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de20e56')) {
      api.createRecord('0de20e56', component.options)
    } else {
      api.reload('0de20e56', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0de20e56&", function () {
      api.rerender('0de20e56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/avenants_tsuppl/index.vue"
export default component.exports